import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  constructor() {}

  makePanelTitle(route: string): string {
    let title = 'CVV';
    switch (route) {
      case 'dispatch': {
        title = 'Dispatch';
        break;
      }
      case 'alerts': {
        title = 'Alerts';
        break;
      }
      case 'myTasks': {
        title = 'My Tasks';
        break;
      }
      case 'unassignedTasks': {
        title = 'Unassigned Tasks';
        break;
      }
      case 'terminal': {
        title = 'Terminal';
        break;
      }
      case 'newTask': {
        title = 'New Task';
        break;
      }
      case 'outbound': {
        title = 'Outbound Flights';
        break;
      }
      case 'manageVans': {
        title = 'Manage Vans';
        break;
      }
      case 'profile': {
        title = 'Profile';
        break;
      }
      case 'settings': {
        title = 'Settings';
        break;
      }
      case 'search': {
        title = 'Search';
        break;
      }
      case 'terminalruns': {
        title = 'Terminal Runs';
        break;
      }
      case 'hide': {
        title = '';
        break;
      }
      default: {
        break;
      }
    }

    return title;
  }
}
